module.exports = __webpack_public_path__ + "0ff32825d39a05f16de0e7602edb855e.glb";